import { request } from '@/utils/request'

/* 司機發訊息總表 */

// get
export const reqDefaultMsg = () => request.get(`defaultMessage`)

export const reqDefaultDriverMsg = () => request.get(`defaultDriverMessage`)

export const reqTeamServiceList = () => request.get(`customerize/list`)

export const reqMsgList = (params) => request.get(`message`, { params })

// post
export const req = () => request.post(``)

// put
export const reqUpdateMsg = (payload) =>
  request.put(`driver/setupCustomerServiceMessage`, payload)

export const reqUpdateDriverMsg = (payload) =>
  request.put(`driver/setupDriverMessage`, payload)



// WEBPACK FOOTER //
// ./src/api/driverMsg/index.js